export const buildQuizHeaders = ({
  tenantKey = "sk_admin_2b136e74df7d426f464d277460c2fe7dee55c339ace8db96068061b535735f3d",
  userId,
  userName,
  tenantId,
  webhookUrl,
  webhookSecret,
} = {}) => {
  const headers = {};
  const includeUserHeaders = process.env.REACT_APP_QUIZ_INCLUDE_USER_HEADERS !== "false";

  if (tenantKey) {
    headers["x-api-key"] = tenantKey;
  }
  if (includeUserHeaders && userId) {
    headers["x-user-id"] = userId;
  }
  if (includeUserHeaders && userName) {
    headers["x-user-name"] = userName;
  }
  if (webhookUrl) {
    headers["x-webhook-url"] = webhookUrl;
  }
  if (webhookSecret) {
    headers["x-webhook-secret"] = webhookSecret;
  }
  return headers;
};
